import React from 'react';
import './ProgressBar.css';

function ProgressBar({ currentPage, totalPages = 9 }) {
  const percentage = (currentPage / totalPages) * 100;

  const steps = [
    { number: 1, label: 'Welcome' },
    { number: 2, label: 'Discovery' },
    { number: 3, label: 'VM Config' },
    { number: 4, label: 'KeyVault' },
    { number: 5, label: 'Storage' },
    { number: 6, label: 'Monitoring' },
    { number: 7, label: 'Tags' },
    { number: 8, label: 'Preview' },
    { number: 9, label: 'Code' }
  ];

  return (
    <div className="progress-bar-container">
      <div className="progress-header">
        <h2>Step {currentPage} of {totalPages}: {steps[currentPage - 1]?.label || 'Unknown'}</h2>
        <span className="progress-percentage">{Math.round(percentage)}%</span>
      </div>
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      <div className="progress-steps">
        {steps.slice(0, totalPages).map((step) => (
          <div
            key={step.number}
            className={`progress-step ${currentPage >= step.number ? 'active' : ''} ${currentPage === step.number ? 'current' : ''}`}
          >
            <div className="step-indicator">{step.number}</div>
            <div className="step-label">{step.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProgressBar;
